export default "__VITE_ASSET__a2acf596__"